var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDowjones(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6500_10896)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8281 17.9938V8.20312L16.2167 8.21661L21.6054 8.2301L22.0663 8.34555C24.3012 8.90531 25.9405 10.3328 26.7426 12.4178C26.9357 12.9197 27.1128 13.7329 27.1453 14.267L27.1719 14.7025H25.5437H23.9154L23.8901 14.494C23.8059 13.8011 23.5874 13.2491 23.1957 12.7401C22.804 12.231 22.2146 11.8182 21.5615 11.5956L21.2103 11.4759L17.6654 11.4635L14.1206 11.451V17.9935V24.5359H15.7448H17.3691V26.1602V27.7845H14.0986H10.8281V17.9938Z",
    fill: "#13A3D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8281 26.1729V24.5491L20.4098 24.5195C20.7297 24.5032 21.1165 24.4606 21.2694 24.4247C22.2078 24.2044 23.1166 23.4869 23.5398 22.6319C23.8938 21.9168 23.881 22.0296 23.8994 19.4544L23.9157 17.1606H25.5401H27.1645L27.148 19.6519L27.1314 22.1432L27.0178 22.6041C26.6987 23.8996 26.1447 24.8907 25.2272 25.8083C24.4825 26.553 23.6596 27.0714 22.6885 27.4075C21.9633 27.6585 21.486 27.7418 20.6073 27.771L19.8281 27.7968V26.1729Z",
    fill: "#13A3D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6500_10896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDowjones);
export default __webpack_public_path__ + "static/media/dowjones.552a9ac42a7e7195f01309a18d757548.svg";
export { ForwardRef as ReactComponent };